export default __webpack_public_path__ + "static/media/customers.cd8ce30d.png";